<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      class="form-control"
      autocomplete="off"
      maxlength="12"
      :id="inputId"
      :disabled="disabled"
      v-model="inputValue"
      @change="emit"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
      @keydown="emit"
    />
    <typeahead
      :async-function="typeahead"
      :data="typeaheadData"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      :target="'#' + inputId"
      v-model="inputValue"
      @input="selectTypeahead"
    >
      <template v-slot:item="props">
        <li
          v-for="(item, index) in props.items"
          v-bind:key="index"
          :class="{active:props.activeIndex===index}"
        >
          <a role="button" @click="props.select(item)">
            <div v-html="props.highlight(item)"></div>
            <div v-if="item && item.org_name">{{ item.org_name }}</div>
            <div v-if="item && item.address">{{ item.address }}</div>
          </a>
        </li>
      </template>
    </typeahead>
    <div v-if="visitor.personal.innControlSumErr" class="form-fielderror trailer-error">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Контрольные суммы не совпадают. Введите правильный ИНН.</div>
      </div>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'

export default {
  name: 'VisitorOrganizationInnInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'ИНН'
    },

    inputName: {
      default: 'organization_inn'
    }
  },

  computed: {
    inputId () {
      return `form-visitor-organization-inn-${this.visitorIndex}`
    }
  }
}
</script>
